/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Replace({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Replace_svg__a)"><path fillRule="evenodd" d="M4 .9a3.1 3.1 0 1 0 0 6.2A3.1 3.1 0 0 0 4 .9M2.1 4a1.9 1.9 0 1 1 3.8 0 1.9 1.9 0 0 1-3.8 0" clipRule="evenodd" /><path d="M11.072 6.079a.6.6 0 0 1-.848-.037L8.558 4.224a.6.6 0 0 1 0-.811l1.666-1.818a.6.6 0 1 1 .885.81l-.745.813h1.97A2.267 2.267 0 0 1 14.6 5.485V7a.6.6 0 1 1-1.2 0V5.485c0-.59-.478-1.067-1.067-1.067h-1.969l.745.813a.6.6 0 0 1-.037.848M2.6 9a.6.6 0 0 0-1.2 0v1.515a2.267 2.267 0 0 0 2.267 2.267h1.969l-.745.813a.6.6 0 0 0 .885.81l1.666-1.818a.6.6 0 0 0 0-.81L5.776 9.957a.6.6 0 0 0-.885.811l.745.813h-1.97c-.588 0-1.066-.478-1.066-1.067z" /><path fillRule="evenodd" d="M8.9 10.5a1.6 1.6 0 0 1 1.6-1.6h3a1.6 1.6 0 0 1 1.6 1.6v3a1.6 1.6 0 0 1-1.6 1.6h-3a1.6 1.6 0 0 1-1.6-1.6zm1.6-.4a.4.4 0 0 0-.4.4v3c0 .22.18.4.4.4h3a.4.4 0 0 0 .4-.4v-3a.4.4 0 0 0-.4-.4z" clipRule="evenodd" /></g><defs><clipPath id="Replace_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;